import { Box, Typography, Button } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { DELTA_ACCENT, DELTA_PRIMARY, ENTERPRISE_TEAL, TEXT_SECONDARY } from "../colors";
import { useAuth } from "../../auth/AuthContext";

export const ProGate = (props: { feature: string; minTier?: "pro" | "enterprise"; description?: string }) => {
  const auth = useAuth();
  const { feature, minTier = "pro", description } = props;

  if (minTier === "enterprise") {
    return (
      <Box style={{ padding: 40, textAlign: "center" }}>
        <Typography variant="h6" style={{ color: DELTA_PRIMARY, fontWeight: 700, marginBottom: 8 }}>
          {feature} is an Enterprise feature
        </Typography>
        <Typography variant="body2" style={{ color: TEXT_SECONDARY, marginBottom: description ? 12 : 24 }}>
          Upgrade to Enterprise to unlock {feature} and other team features like SSO and PDF company reports.
        </Typography>
        {description && (
          <Typography
            variant="body2"
            style={{ color: TEXT_SECONDARY, marginBottom: 24, maxWidth: 480, marginLeft: "auto", marginRight: "auto" }}
          >
            {description}
          </Typography>
        )}
        <Button
          href="mailto:support@deltagain.co.uk?subject=Enterprise%20plan"
          variant="contained"
          style={{ backgroundColor: ENTERPRISE_TEAL }}
        >
          Contact Sales
        </Button>
      </Box>
    );
  }

  if (auth.status === "signedIn") {
    return (
      <Box style={{ padding: 40, textAlign: "center" }}>
        <Typography variant="h6" style={{ color: DELTA_PRIMARY, fontWeight: 700, marginBottom: 8 }}>
          {feature} is a Pro or Enterprise feature
        </Typography>
        <Typography variant="body2" style={{ color: TEXT_SECONDARY, marginBottom: 24 }}>
          Subscribe to Pro or Enterprise to unlock {feature} and more.
        </Typography>
        <Button component={RouterLink} to="/" variant="contained" style={{ backgroundColor: DELTA_ACCENT }}>
          View Plans
        </Button>
      </Box>
    );
  }

  return (
    <Box style={{ padding: 40, textAlign: "center" }}>
      <Typography variant="h6" style={{ color: DELTA_PRIMARY, fontWeight: 700, marginBottom: 8 }}>
        Sign in to unlock {feature}
      </Typography>
      <Typography variant="body2" style={{ color: TEXT_SECONDARY, marginBottom: 24 }}>
        {feature} is a Pro or Enterprise feature. Sign in or create a free account, then subscribe to get access.
      </Typography>
      <Button component={RouterLink} to="/login" variant="contained" style={{ backgroundColor: DELTA_ACCENT }}>
        Sign In
      </Button>
    </Box>
  );
};

export default ProGate;
